import { useRouter } from 'next/router';

export default function useTicketKey(): string {
    const {
        query: { ticketKey }
    } = useRouter();

    return ticketKey as string;
}
